/* src/app/shared/components/pdf-view/pdf-view.component.scss */
.controls {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 0;
  text-align: center;
}
.controls .controls__zoomControls-resetButton {
  margin-left: 20px;
}
.controls .controls__leftSpace {
  width: 122px;
  margin-left: 20px;
}
.controls .controls__downloadTranscriptButton {
  margin-right: 20px;
}
.loadingProgress {
  text-align: center;
}
.loadingError {
  text-align: center;
  color: #a41f35;
  padding: 10px 0;
}
.pdfViewerContainer {
  position: relative;
  width: 100%;
  min-width: 300px;
  max-width: 90vw;
  transition: width 0.1s;
  display: flex;
}
.pdfViewerContainer .pdfViewer {
  flex-basis: 100%;
}
.resize-handle {
  width: 8px;
  cursor: ew-resize;
  position: absolute;
  top: 0;
  right: -8px;
  height: 100%;
  z-index: 10;
  background: rgba(0, 0, 0, 0.05);
}
/*# sourceMappingURL=pdf-view.component.css.map */
